import { render, staticRenderFns } from "./LoadingForPC.vue?vue&type=template&id=010514e0&scoped=true&"
import script from "./LoadingForPC.vue?vue&type=script&lang=js&"
export * from "./LoadingForPC.vue?vue&type=script&lang=js&"
import style0 from "./LoadingForPC.vue?vue&type=style&index=0&id=010514e0&scoped=true&lang=less&"
import style1 from "./LoadingForPC.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010514e0",
  null
  
)

export default component.exports